export const userDataAction = (payload) => ({
  type: '@user/userData',
  payload
})